import {SortDirection} from "../../../data-structures/sort"
import {SystemColumnType} from "../../manager/columns/types"
import {SystemStatusGroup} from "../../../gd/const/system-status"
import {Board_CardSize} from "./@types"
import {CardViewLayout} from "../../../gd-ui/card-view-selector/card-view-selector"
import {GroupingType} from "../../../gd/manager/group-by/@types"

export const TasksView_Board_DefaultAppSettings = {
    columns                 : _.map([
        {
            id      : SystemColumnType.TITLE
        },
        {
            id      : SystemColumnType.TASK_ID
        },
        {
            id      : SystemColumnType.ACTION_REQUIRED
        },
    ]),
    grouping                : { // current grouping value
        mode    : GroupingType.COLUMNS,
        fields  : [{
            fieldId         : 'statusId',
            sortDirection   : SortDirection.ASC,
            params          : {}
        }]
    },
    boardViewSize           : Board_CardSize.MEDIUM,
    colorTasksFieldId       : 'statusId',
    itemViewBorderPosition  : CardViewLayout.COLOR_CODING_BORDER_LEFT,
    systemStatusFilter      : SystemStatusGroup.ALL,
    filters                 : {},
    showSubfolders          : true, // show subfolders as separate cards
    showSubTasks            : false,  // false = show counter
    showEmptyColumns        : true,
    showEmptyRows           : true,
    columnsAggregate        : undefined,
    rowsAggregate           : undefined,

    // old board group by manager
    boardViewRowGroupBy     : {
        fieldId         : undefined,
        sortDirection   : SortDirection.ASC,
        params          : {}
    },
    boardViewColumnGroupBy : {
        fieldId         : 'statusId',
        sortDirection   : SortDirection.ASC,
        params          : {}
    },
    boardCardColorFieldId   : 'statusId', // old color coding field
    boardViewBorderPosition : 'left', // old color coding board position
}
